import axios from '../../../utills/axiosConfig';

export const fetchCompanies = async () => {
  const res = await axios.get('/companies');
  return res.data;
};

export const addCompany = async (company) => {
  const res = await axios.post('/companies', company);
  return res.data;
};

export const updateCompany = async (id, company) => {
  const res = await axios.put(`/companies/${id}`, company);
  return res.data;
};

export const deleteCompany = async (id) => {
  const res = await axios.delete(`/companies/${id}`);
  return res.data;
}; 